import script from "./MyClassesView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyClassesView.vue?vue&type=script&setup=true&lang=ts"

import "./MyClassesView.vue?vue&type=style&index=0&id=d0d8c41c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.16_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0d8c41c"]])

export default __exports__